module.exports = require('./schema')


/*****************
 ** WEBPACK FOOTER
 ** ./src/mock/schema/index.js
 ** module id = 23
 ** module chunks = 0
 **/